<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>医疗服务指引</a></li>
            </ul>
            <div class="page-main">
                <img class="medicalGuideImg" src="@/assets/image/medical_guide.png" />
                <div class="medicalGuideForm">
                    <h3>医疗服务指引</h3>
                    <el-form :label-position="labelPosition" label-width="140px" :model="form" :rules="rules" ref="ruleForm" class="form" size="small">
                        <el-form-item label="医院名称" prop="name">
                            <el-input v-model="form.name"></el-input>
                        </el-form-item>
                        <el-form-item label="科室" prop="department">
                            <el-input v-model="form.department"></el-input>
                        </el-form-item>
                        <el-form-item label="专家" prop="expert">
                            <el-input v-model="form.expert"></el-input>
                        </el-form-item>
                        <el-form-item label="就医日期" prop="time">
                            <el-date-picker
                                v-model="form.time"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="会员单位" prop="work">
                            <el-input v-model="form.work"></el-input>
                        </el-form-item>
                        <el-form-item label="会员姓名" prop="vipName">
                            <el-input v-model="form.vipName"></el-input>
                        </el-form-item>
                        <el-form-item label="会员联系方式" prop="phone">
                            <el-input v-model="form.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="患者姓名" prop="patientName">
                            <el-input v-model="form.patientName"></el-input>
                        </el-form-item>
                        <el-form-item label="是否有会员单位">
                            <el-radio-group v-model="form.isHasVip">
                                <el-radio label='是'>是</el-radio>
                                <el-radio label='否'>否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="其他说明">
                            <el-input :autosize="{ minRows: 4, maxRows: 6}" type="textarea" v-model="form.memo"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="onSubmit" class="submitBtn">提交</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import rulesPattern from '@/assets/utils/rulesPattern.js';
import {
    addMatericalService
} from '@services/indexService.js';
export default {
    name: '',
    data() {
        return {
            labelPosition: 'right',
            form:{
                name: '',
                department: '',
                expert: '',
                time: '',
                phone: '',
                email: '',
                work: '',
                tel: '',
                patientName: '',
                isHasVip: '是',
                memo: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入医院名称', trigger: 'blur' },
                ],
                department: [
                    { required: true, message: '请输入科室', trigger: 'blur' },
                ],
                expert: [
                    { required: true, message: '请输入专家', trigger: 'blur' },
                ],
                time: [
                    { required: true, message: '请输入就医日期', trigger: 'blur' },
                ],
                vipName: [
                    { required: true, message: '请输入会员姓名', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入会员联系方式', trigger: 'blur' },
                    { pattern: rulesPattern.phoneAndTel, message: '请输入正确的手机号或者座机号格式为：0000-0000000', trigger: 'blur' },
                ],
                work: [
                    { required: true, message: '请输入会员单位', trigger: 'blur' },
                ],
                patientName: [
                    { required: true, message: '请输入患者姓名', trigger: 'blur' },
                ],
            }
        };
    },
    created() {
    },
    methods: {
        addMatericalService() {
            let params = {
                EnterpriseName: this.form.name,
                Business: this.form.department,
                Postion: this.form.expert,
                UpdateTime: this.form.time,
                WeChat:  this.form.work, // 会员单位
                Contact: this.form.vipName, //会员姓名
                Phone: this.form.phone,
                Email: this.form.patientName, // 患者姓名
                Relationship: this.form.isHasVip, //  是否有会员单位
                Remarks: this.form.memo, // 其他说明
            };
            addMatericalService(params).then(res => {
                if (res.Code == 1) {
                    this.$message.success("操作成功！");
                } else {
                    this.$message.error(res.Message);
                }
            })
        },
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.addMatericalService();
                } else {
                    return false;
                }
            });
        }
    },
};
</script>

<style scoped>
.page-main {
    background: #fff;
    padding:0;
    box-sizing: border-box;
}
.medicalGuideImg {
    width: 530px;
    height: 800px;
}
.page-main h3 {
    color: #262626;
    font-size: 22px;
    text-align: center;
    margin-bottom: 30px;
}
.medicalGuideForm{
    padding-top: 30px;
    width: 750px;
    height: 800px;
    box-sizing: border-box;
}
.medicalGuideForm .form {
    width: 498px;
    margin: 0 auto;
}
.expert-forum-list {
    padding-top:20px;
    padding-bottom: 10px;
}
.expert-forum {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 20px;
}
.expert-forum img {
    width: 218px;
    height: 137px;
}
.expert-forum-des {
    padding-left: 20px;
}
.expert-forum-des h4 {
    color: #262626;
    font-family: 思源黑体 CN;
    font-size: 18px;
    margin: 0;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
}
.expert-forum-des p {
    color: #6a6a6a;
    font-family: 思源黑体 CN;
    font-size: 14px;
}
.expert-forum-des .date{
    padding-top: 10px;
    color: #A1A8B0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.expert-forum-des .date img{
    width: 15px;
    height: 15px;
}
.expert-forum-des .date i {
    font-style: normal;
}
.info-data-bar {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 10px;
}
.info-pool-tag {
    width: 56px;
    height: 20px;
    padding: 2px 4px 2px 4px;
    background: #0090f0;
    color: #fff;
    margin-right: 10px;
}
.info-pool-button {
    width: 80px;
    height: 24px;
    line-height: 24px;
    border: 1px solid #116EBA;
    color: #116EBA;
    cursor: pointer;
    text-align: center;
    box-sizing: border-box;
    transition: all 0.36s;
}
.info-pool-button:hover {
    color: #fff;
    background: #116EBA;
}
</style>
<style>
.medicalGuideForm .el-date-editor.el-input,
.medicalGuideForm .el-date-editor.el-input__inner {
    width: 358px;
}
</style>